<template>
    <div class="s-entry-form_item">
          <div class="s-entry-form_item-q">
            <p><slot name="title"></slot></p>
            <p class="hissu" v-show="hissu">必須</p>
          </div>
          <div class="s-entry-form_item-a">
              <slot></slot>
              <slot name="error"></slot>
          </div>
        </div>
</template>

<script>
export default {
    name:"form_waku",
    props:{
        hissu:Boolean
    }
}
</script>

<style lang="scss">
.s-entry {
  &-form {
    text-align: left;
    &_item {
      display: grid;
      align-items: center;
      &-q {
        display: grid;
        align-items: center;
        background-color: rgb(243, 243, 243);
        .font-red {
          color: rgb(240, 60, 60);
        }
        .hissu {
          background-color: red;
          color: #fff;
          padding: 0 2%;
          font-size: 80%;
        }
        .font-red {
          font-size: 90%;
        }
      }
      &-a {
        &-item {
          input,
          textarea,
          select {
            font-size: 90%;
            padding: 1%;
          }
        }
      }
      .error {
        color: red;
        font-size: 90%;
        margin: 2% 0 -3% 2%;
      }

      .address-search {
        margin: 0 3%;
        text-decoration: none;
        color: rgb(255, 253, 253);
        padding: 1% 2%;
        background-color: #969696;
        font-size: 80%;
      }
      .flex {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        &-item {
          width: 40%;
        }
      }
    }
  }
}
@media screen and (min-width: 769px) {
  .s-entry {
    &-form {
      max-width: 800px;
      margin: 0 auto;
      border: 1px solid rgb(200, 200, 200);
      border-bottom: none;
      &_item {
        grid-template-columns: 30% 1fr;
        border-bottom: 1px solid rgb(200, 200, 200);
        &-q {
          grid-column-start: 1;
          grid-template-areas: "areaA areaB";
          padding: 0 10px;
          font-size: 120%;
          position: relative;
          height: 100%;
          .hissu {
            position: absolute;
            right: 5%;
          }
        }
        &-a {
          font-size: 110%;
          margin: 5% 2%;
          &-item {
            padding: 1%;
          }
          .name {
            width: 15em;
          }
          .addless {
            width: 96%;
            margin-top: 2%;
          }
          .yubin-num {
            width: 4.5em;
          }
          .email {
            width: 80%;
          }
          .textarea-q {
            width: 97%;
            height: 7em;
          }
        }
        .flex {
          &-item {
            width: 31%;
          }
        }
      }
    }
  }
}
//smartphone style
@media screen and (max-width: 768px) {
  .s-entry {
    &-form {
      margin-left: 1%;
      width: 98%;
      &_item {
        grid-template-rows: auto 1fr;
        margin: 5% 0;
        box-shadow: 0 0 8px rgb(155, 155, 155);
        &-q {
          grid-column-start: 1;
          display: flex;
          padding-left: 5%;
          font-size: 120%;
          .hissu {
            margin: 0 2%;
          }
        }
        &-a {
          padding: 5% 3%;
          font-size: 110%;
          &-item {
            .name {
              width: 60%;
            }
            .year {
              width: 20%;
            }
            .month {
              width: 10%;
            }
            .yubin-num {
              width: 25%;
            }
            .addless {
              width: 96%;
            }
            .email {
              width: 96%;
            }
            .textarea-q {
              width: 98%;
              line-height: 5em;
            }
          }
          .error {
            margin: 3% 0 2%;
          }
          input {
            margin: 3% 0;
            padding: 2% 1%;
            font-size: 110%;
          }
        }
        .flex {
          &-item {
            width: 50%;
            margin: 2% 0;
          }
        }
      }
    }
  }
}
</style>